
import upload from './Upload';
import uploadDialog from './UploadDialog';

const Uploader =  {
    upload,
    uploadDialog
}
export default Uploader